import { cons, singleton as singleton_2, map as map_2, splitAt, append, length as length_2, windowed, tryFindIndexBack, ofArray, tryPick, fold } from "./fable_modules/fable-library.3.7.20/List.js";
import { endsWith, replace as replace_1, isNullOrWhiteSpace, split, substring, printf, toText, join } from "./fable_modules/fable-library.3.7.20/String.js";
import { toArray, map as map_1, defaultArg, some, value as value_2 } from "./fable_modules/fable-library.3.7.20/Option.js";
import { Record, FSharpRef, Union, toString } from "./fable_modules/fable-library.3.7.20/Types.js";
import * as react from "react";
import { bool_type, record_type, string_type, class_type, union_type } from "./fable_modules/fable-library.3.7.20/Reflection.js";
import { compare as compare_2, addMonths as addMonths_1, fromDateTimeOffset, daysInMonth, month, year, create as create_1, day, addDays, toUniversalTime, toString as toString_1, now as now_1, op_Subtraction, utcNow, tryParse, minValue } from "./fable_modules/fable-library.3.7.20/Date.js";
import { create as create_3, toDateTime, day as day_2, month as month_1, year as year_1, tryParse as tryParse_1, minValue as minValue_1 } from "./fable_modules/fable-library.3.7.20/DateOnly.js";
import { op_UnaryNegation_Int32, parse, tryParse as tryParse_2 } from "./fable_modules/fable-library.3.7.20/Int32.js";
import { toNumber, tryParse as tryParse_3, fromInt } from "./fable_modules/fable-library.3.7.20/Long.js";
import { tryParse as tryParse_4 } from "./fable_modules/fable-library.3.7.20/Double.js";
import { round, op_Division, compare, fromParts, tryParse as tryParse_5 } from "./fable_modules/fable-library.3.7.20/Decimal.js";
import Decimal from "./fable_modules/fable-library.3.7.20/Decimal.js";
import { empty as empty_1, singleton as singleton_1, append as append_1, collect, delay, exists, tail, tryHead as tryHead_1, toList as toList_1, fold as fold_2, item, last, filter, reverse, mapIndexed, sum as sum_1, length as length_1, map, forAll } from "./fable_modules/fable-library.3.7.20/Seq.js";
import { isNumber } from "./fable_modules/fable-library.3.7.20/Char.js";
import { tryFind as tryFind_1, map as map_3, choose, tryLast, tryHead, fold as fold_1 } from "./fable_modules/fable-library.3.7.20/Array.js";
import { compare as compare_1, sign, structuralHash, equals, uncurry } from "./fable_modules/fable-library.3.7.20/Util.js";
import { create, match, replace } from "./fable_modules/fable-library.3.7.20/RegExp.js";
import { remove, isEmpty, tryFind, fold as fold_3, ofArray as ofArray_1, add, FSharpMap__TryGetValue, empty } from "./fable_modules/fable-library.3.7.20/Map.js";
import { Dictionary } from "./fable_modules/fable-library.3.7.20/MutableMap.js";
import { addToDict, tryGetValue } from "./fable_modules/fable-library.3.7.20/MapUtil.js";
import { totalSeconds } from "./fable_modules/fable-library.3.7.20/TimeSpan.js";
import { StringBuilder__Append_244C7CD6, StringBuilder_$ctor, StringBuilder__Append_Z721C83C5, StringBuilder_$ctor_Z524259A4 } from "./fable_modules/fable-library.3.7.20/System.Text.js";
import { singleton } from "./fable_modules/fable-library.3.7.20/AsyncBuilder.js";
import { sleep } from "./fable_modules/fable-library.3.7.20/Async.js";
import { Swedish } from "flatpickr/dist/l10n/sv";
import { Finnish } from "flatpickr/dist/l10n/fi.js";
import { Norwegian } from "flatpickr/dist/l10n/no.js";
import { english } from "flatpickr/dist/l10n/default";
import { enGB, nb, fi, sv } from "date-fns/locale";
import { format as format_1 } from "date-fns";
import { UTC__get_Day, UTC__get_Month, UTC__get_Year, UTC_ofDateTime_7F9DDECF } from "./fable_modules/Svea.Dry.Fable.1.0.4/Time.fs.js";
import { addMonths, day as day_1, addDays as addDays_1, toUniversalTime as toUniversalTime_1 } from "./fable_modules/fable-library.3.7.20/DateOffset.js";
import { create as create_2 } from "./fable_modules/fable-library.3.7.20/TimeOnly.js";
import { rangeDouble } from "./fable_modules/fable-library.3.7.20/Range.js";

export function classNames(classes) {
    const s = fold((acc, tupledArg) => {
        if (tupledArg[1]) {
            return (acc + " ") + tupledArg[0];
        }
        else {
            return acc;
        }
    }, "", classes);
    return s.trim();
}

export const stackClasses = (s) => join(" ", s);

export function optToStr(_arg) {
    if (_arg == null) {
        return "";
    }
    else {
        let copyOfStruct = value_2(_arg);
        return toString(copyOfStruct);
    }
}

export function strToOpt(_arg) {
    if (_arg === "") {
        return void 0;
    }
    else {
        return _arg;
    }
}

export function optToHtml(_arg) {
    if (_arg != null) {
        return _arg;
    }
    else {
        return react.createElement(react.Fragment, {});
    }
}

export class LogLevel extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Info", "Warning", "Error"];
    }
}

export function LogLevel$reflection() {
    return union_type("Utils.LogLevel", [], LogLevel, () => [[], [], []]);
}

function log(a, level) {
    const infoColor = "background: #222; color: #fff";
    const warnColor = "background: #222; color: #bada55";
    const errorColor = "background: #222; color: red";
    switch (level.tag) {
        case 1: {
            console.log(some("%c          LOG WARNING          "), warnColor);
            console.warn(some(a));
            console.log(some("%c            LOG END            "), warnColor);
            break;
        }
        case 2: {
            console.log(some("%c           LOG ERROR           "), errorColor);
            console.error(some(a));
            console.log(some("%c            LOG END            "), errorColor);
            break;
        }
        default: {
            console.log(some("%c           LOG INFO           "), infoColor);
            console.info(some(a));
            console.log(some("%c            LOG END           "), infoColor);
        }
    }
    return a;
}

export function logi(a) {
    return log(a, new LogLevel(0));
}

export function logii(a) {
    logi(a);
}

export function logw(a) {
    return log(a, new LogLevel(1));
}

export function logwi(a) {
    log(a, new LogLevel(1));
}

export function loge(a) {
    return log(a, new LogLevel(2));
}

export function logei(a) {
    log(a, new LogLevel(2));
}

function tryParseBoolean(str) {
    const matchValue = str.trim().toLocaleLowerCase();
    switch (matchValue) {
        case "true": {
            return true;
        }
        case "false": {
            return false;
        }
        default: {
            return void 0;
        }
    }
}

function tryParseWith(tryParseFunc) {
    return (arg) => {
        const _arg = tryParseFunc(arg);
        return _arg[0] ? some(_arg[1]) : (void 0);
    };
}

export const parseDateTime = tryParseWith((arg) => {
    let outArg = minValue();
    return [tryParse(arg, new FSharpRef(() => outArg, (v) => {
        outArg = v;
    })), outArg];
});

export const parseDateOnly = tryParseWith((arg) => {
    let outArg = minValue_1();
    return [tryParse_1(arg, new FSharpRef(() => outArg, (v) => {
        outArg = v;
    })), outArg];
});

export const parseInt$ = tryParseWith((arg) => {
    let outArg = 0;
    return [tryParse_2(arg, 511, false, 32, new FSharpRef(() => outArg, (v) => {
        outArg = (v | 0);
    })), outArg];
});

export const parseInt16 = tryParseWith((arg) => {
    let outArg = 0;
    return [tryParse_2(arg, 511, false, 16, new FSharpRef(() => outArg, (v) => {
        outArg = (v | 0);
    })), outArg];
});

export const parseInt64 = tryParseWith((arg) => {
    let outArg = fromInt(0);
    return [tryParse_3(arg, 511, false, 64, new FSharpRef(() => outArg, (v) => {
        outArg = v;
    })), outArg];
});

export const parseSingle = tryParseWith((arg) => {
    let outArg = 0;
    return [tryParse_4(arg, new FSharpRef(() => outArg, (v) => {
        outArg = v;
    })), outArg];
});

export const parseDouble = tryParseWith((arg) => {
    let outArg = 0;
    return [tryParse_4(arg, new FSharpRef(() => outArg, (v) => {
        outArg = v;
    })), outArg];
});

export const parseBool = tryParseBoolean;

export const parseDecimal = tryParseWith((arg) => {
    let outArg = new Decimal(0);
    return [tryParse_5(arg, new FSharpRef(() => outArg, (v) => {
        outArg = v;
    })), outArg];
});

export const parseByte = tryParseWith((arg) => {
    let outArg = 0;
    return [tryParse_2(arg, 511, true, 8, new FSharpRef(() => outArg, (v) => {
        outArg = v;
    })), outArg];
});

export const $007CDateTime$007C_$007C = parseDateTime;

export const $007CDateOnly$007C_$007C = parseDateOnly;

export const $007CInt$007C_$007C = parseInt$;

export const $007CInt16$007C_$007C = parseInt16;

export const $007CInt64$007C_$007C = parseInt64;

export const $007CSingle$007C_$007C = parseSingle;

export const $007CDouble$007C_$007C = parseDouble;

export const $007CBool$007C_$007C = parseBool;

export const $007CDecimal$007C_$007C = parseDecimal;

export const $007CByte$007C_$007C = parseByte;

export function luhn(numberString) {
    if (!forAll(isNumber, numberString.split(""))) {
        return false;
    }
    else {
        const digits = map((arg_1) => parse(arg_1, 511, false, 32), numberString.split(""));
        if (length_1(digits) !== 0) {
            return (sum_1(mapIndexed((i, n) => {
                const matchValue = (i % 2) | 0;
                if (matchValue === 1) {
                    if (n < 5) {
                        return (n * 2) | 0;
                    }
                    else {
                        return ((n * 2) - 9) | 0;
                    }
                }
                else {
                    return n | 0;
                }
            }, reverse(digits)), {
                GetZero: () => 0,
                Add: (x, y) => (x + y),
            }) % 10) === 0;
        }
        else {
            return false;
        }
    }
}

export function luhnCheck(number, alpha3CountryCode) {
    const matchValue = alpha3CountryCode.toLocaleUpperCase();
    switch (matchValue) {
        case "SWE": {
            return luhn(join("", filter(isNumber, number.split(""))));
        }
        case "NOR": {
            const digits = map((arg_3) => parse(arg_3, 511, false, 32), filter(isNumber, number.split("")));
            const matchValue_1 = length_1(digits) | 0;
            switch (matchValue_1) {
                case 9: {
                    const checkNo = last(digits) | 0;
                    const rem = (fold_1(uncurry(2, (tupledArg) => {
                        const i = tupledArg[0] | 0;
                        return (w) => [i + 1, tupledArg[1] + (item(i, digits) * w)];
                    }), [0, 0], new Int32Array([3, 2, 7, 6, 5, 4, 3, 2]))[1] % 11) | 0;
                    const cn = ((rem === 0) ? 0 : (11 - rem)) | 0;
                    if (cn >= 10) {
                        return false;
                    }
                    else {
                        return cn === checkNo;
                    }
                }
                case 11: {
                    const weights2 = new Int32Array([5, 4, 3, 2, 7, 6, 5, 4, 3, 2, 1]);
                    if ((fold_1(uncurry(2, (tupledArg_1) => {
                        const i_1 = tupledArg_1[0] | 0;
                        return (w_1) => [i_1 + 1, tupledArg_1[1] + (item(i_1, digits) * w_1)];
                    }), [0, 0], new Int32Array([3, 7, 6, 1, 8, 9, 4, 5, 2, 1]))[1] % 11) === 0) {
                        return true;
                    }
                    else {
                        return (fold_1(uncurry(2, (tupledArg_2) => {
                            const i_2 = tupledArg_2[0] | 0;
                            return (w_2) => [i_2 + 1, tupledArg_2[1] + (item(i_2, digits) * w_2)];
                        }), [0, 0], weights2)[1] % 11) === 0;
                    }
                }
                default: {
                    return false;
                }
            }
        }
        default: {
            if (number.length <= 11) {
                return number.length > 0;
            }
            else {
                return false;
            }
        }
    }
}

export function removeWhitespace(str) {
    return replace(str, "\\s", "");
}

export class IdentificationNumber extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["OrganisationNumber", "SocialSecurityNumber", "Empty", "NotSupportedNumber"];
    }
}

export function IdentificationNumber$reflection() {
    return union_type("Utils.IdentificationNumber", [], IdentificationNumber, () => [[], [], [], []]);
}

export function getIdNumberType(number, isoCountryCode) {
    if ((number == null) ? true : (number.length === 0)) {
        return new IdentificationNumber(2);
    }
    else {
        const isValidRegex = (input, regex) => {
            let tupledArg;
            return ((tupledArg = [input, regex], match(create(tupledArg[1]), tupledArg[0]))) != null;
        };
        const isFinnishSSN = (number_1) => isValidRegex(number_1.toLocaleUpperCase(), "^(0[1-9]|[12]\\d|3[01])(0[1-9]|1[0-2])([5-9]\\d\\+|\\d\\d-|[01]\\dA)\\d{3}[\\dABCDEFHJKLMNPRSTUVWXY]$");
        const isFinnishOrgNr = (number_2) => isValidRegex(number_2, "^\\d{7}-\\d{1}$");
        const isSwedishSSN = (number_3) => isValidRegex(number_3, "^(\\d{2}){0,1}(\\d{2})([0-1][0-9])(\\d{2})([-|+]{0,1})?(\\d{3})(\\d{0,1})$");
        const isSwedishOrgNr = (number_4) => isValidRegex(number_4, "^[\\d]{2}[2-9]\\d[\\d]{2}-?[\\d]{4}$");
        const isNorwegianSSN = (number_5) => isValidRegex(number_5, "^[0-3]\\d[0-1]\\d\\d\\d([ -]?)(\\d{3})?(\\d{2})?$");
        const isNorwegianOrgNr = (number_6) => isValidRegex(number_6, "^[8-9][0-9]{8}$");
        const isDanishCPR = (number_7) => {
            let tupledArg_1;
            return ((tupledArg_1 = [number_7, "^(0[1-9]|[12]\\d|3[01])(0[1-9]|1[0-2])\\d{2}[-]?\\d{4}$"], match(create(tupledArg_1[1]), tupledArg_1[0]))) != null;
        };
        const isDanishCVR = (number_8) => {
            let tupledArg_2;
            return ((tupledArg_2 = [number_8, "^[0-9]{8}$"], match(create(tupledArg_2[1]), tupledArg_2[0]))) != null;
        };
        if (isoCountryCode == null) {
            return defaultArg(tryPick((tupledArg_3) => {
                if (tupledArg_3[0](number)) {
                    return tupledArg_3[1];
                }
                else {
                    return void 0;
                }
            }, ofArray([[isSwedishSSN, new IdentificationNumber(1)], [isSwedishOrgNr, new IdentificationNumber(0)], [isNorwegianSSN, new IdentificationNumber(1)], [isNorwegianOrgNr, new IdentificationNumber(0)], [isFinnishSSN, new IdentificationNumber(1)], [isFinnishOrgNr, new IdentificationNumber(0)], [isDanishCPR, new IdentificationNumber(1)], [isDanishCVR, new IdentificationNumber(0)]])), new IdentificationNumber(3));
        }
        else {
            const countryCode = isoCountryCode;
            const countryCode$0027 = countryCode.ThreeLetter.toLocaleUpperCase();
            const number_9 = removeWhitespace(number);
            const getNumberType = (isSSN, isOrgNr) => {
                const matchValue = [isSSN, isOrgNr];
                if (matchValue[0]) {
                    return new IdentificationNumber(1);
                }
                else if (matchValue[1]) {
                    return new IdentificationNumber(0);
                }
                else {
                    return new IdentificationNumber(3);
                }
            };
            switch (countryCode$0027) {
                case "SWE": {
                    return getNumberType(isSwedishSSN(number_9), isSwedishOrgNr(number_9));
                }
                case "NOR": {
                    return getNumberType(isNorwegianSSN(number_9), isNorwegianOrgNr(number_9));
                }
                case "FIN": {
                    return getNumberType(isFinnishSSN(number_9), isFinnishOrgNr(number_9));
                }
                case "DNK": {
                    return getNumberType(isDanishCPR(number_9), isDanishCVR(number_9));
                }
                default: {
                    return new IdentificationNumber(3);
                }
            }
        }
    }
}

export function ssnOrOrgNrToValidFormat(number, alpha3CountryCode) {
    const number_1 = number.trim();
    const removeHyphen = (str) => {
        let regexMatch;
        const tupledArg = [str, "^(\\d*)(-)(\\d*)$"];
        regexMatch = match(create(tupledArg[1]), tupledArg[0]);
        if (regexMatch != null) {
            return (regexMatch[1] || "") + (regexMatch[3] || "");
        }
        else {
            return str;
        }
    };
    const idNrType = getIdNumberType(number_1, alpha3CountryCode);
    const matchValue = [map_1((x) => x.ThreeLetter.toLocaleUpperCase(), alpha3CountryCode), idNrType];
    let pattern_matching_result;
    if (matchValue[0] != null) {
        if (matchValue[0] === "SWE") {
            if (matchValue[1].tag === 1) {
                pattern_matching_result = 0;
            }
            else if (matchValue[1].tag === 0) {
                pattern_matching_result = 1;
            }
            else {
                pattern_matching_result = 6;
            }
        }
        else if (matchValue[0] === "NOR") {
            if (matchValue[1].tag === 1) {
                pattern_matching_result = 2;
            }
            else if (matchValue[1].tag === 0) {
                pattern_matching_result = 3;
            }
            else {
                pattern_matching_result = 6;
            }
        }
        else if (matchValue[0] === "DNK") {
            if (matchValue[1].tag === 1) {
                pattern_matching_result = 4;
            }
            else if (matchValue[1].tag === 0) {
                pattern_matching_result = 5;
            }
            else {
                pattern_matching_result = 6;
            }
        }
        else {
            pattern_matching_result = 6;
        }
    }
    else {
        pattern_matching_result = 6;
    }
    switch (pattern_matching_result) {
        case 0: {
            const str_1 = removeHyphen(removeWhitespace(number_1));
            if (str_1.length === 12) {
                let regexMatch_1;
                const tupledArg_1 = [str_1, "^(19|20)(\\d*)$"];
                regexMatch_1 = match(create(tupledArg_1[1]), tupledArg_1[0]);
                if (regexMatch_1 != null) {
                    return regexMatch_1[2] || "";
                }
                else {
                    return str_1;
                }
            }
            else {
                return str_1;
            }
        }
        case 1: {
            return removeHyphen(removeWhitespace(number_1));
        }
        case 2: {
            return removeHyphen(removeWhitespace(number_1));
        }
        case 3: {
            return removeHyphen(removeWhitespace(number_1));
        }
        case 4: {
            return removeHyphen(removeWhitespace(number_1));
        }
        case 5: {
            return removeWhitespace(number_1);
        }
        case 6: {
            return number_1;
        }
    }
}

export function doubleToTwoDecimals(number) {
    return toText(printf("%.2f"))(number);
}

export function decimalToTwoDecimals(number) {
    return toText(printf("%.2f"))(number);
}

export function memoize(fn) {
    let cache = empty();
    return (x) => {
        let matchValue;
        let outArg = null;
        matchValue = [FSharpMap__TryGetValue(cache, x, new FSharpRef(() => outArg, (v) => {
            outArg = v;
        })), outArg];
        if (matchValue[0]) {
            return matchValue[1];
        }
        else {
            const v_2 = fn(x);
            cache = add(x, v_2, cache);
            return v_2;
        }
    };
}

export function memoizeByKey(seconds, key, f) {
    const dict = new Dictionary([], {
        Equals: equals,
        GetHashCode: structuralHash,
    });
    return (n) => {
        let copyOfStruct;
        const keyValue = key(n);
        const now = utcNow();
        let matchValue;
        let outArg = [minValue(), null];
        matchValue = [tryGetValue(dict, keyValue, new FSharpRef(() => outArg, (v) => {
            outArg = v;
        })), outArg];
        if (matchValue[0]) {
            if (seconds > ((copyOfStruct = op_Subtraction(now, matchValue[1][0]), totalSeconds(copyOfStruct)))) {
                return matchValue[1][1];
            }
            else {
                const temp = f(n);
                dict.set(keyValue, [now, temp]);
                return temp;
            }
        }
        else {
            const temp_1 = f(n);
            if (dict.has(keyValue)) {
            }
            else {
                addToDict(dict, keyValue, [now, temp_1]);
            }
            return temp_1;
        }
    };
}

export function formatUrl(currentSegments, baseSegments, additionalSegments) {
    const _arg = tryFindIndexBack((segments) => equals(segments, baseSegments), windowed(length_2(baseSegments), currentSegments));
    if (_arg != null) {
        return append(splitAt(_arg, currentSegments)[0], append(baseSegments, additionalSegments));
    }
    else {
        return append(currentSegments, append(baseSegments, additionalSegments));
    }
}

export function getStars(amount) {
    const sb = StringBuilder_$ctor_Z524259A4(amount);
    for (let forLoopVar = 1; forLoopVar <= amount; forLoopVar++) {
        StringBuilder__Append_Z721C83C5(sb, "*");
    }
    return toString(sb);
}

export function maskSSN(orgNr, alpha3CountryCode) {
    const matchValue = [alpha3CountryCode.ThreeLetter, getIdNumberType(orgNr, alpha3CountryCode)];
    let pattern_matching_result;
    if (matchValue[0] === "FIN") {
        if (matchValue[1].tag === 1) {
            pattern_matching_result = 0;
        }
        else {
            pattern_matching_result = 2;
        }
    }
    else if (matchValue[0] === "NOR") {
        if (matchValue[1].tag === 1) {
            pattern_matching_result = 1;
        }
        else {
            pattern_matching_result = 2;
        }
    }
    else {
        pattern_matching_result = 2;
    }
    switch (pattern_matching_result) {
        case 0: {
            return substring(orgNr, 0, 2) + getStars(orgNr.length - 2);
        }
        case 1: {
            return substring(orgNr, 0, 6) + getStars(orgNr.length - 6);
        }
        case 2: {
            return orgNr;
        }
    }
}

export function decodeUriString(str) {
    try {
        return decodeURIComponent(str);
    }
    catch (e) {
        logei(e);
        return void 0;
    }
}

export function encodeUriString(str) {
    return encodeURIComponent(str);
}

export function normalizePhoneNumber(phoneNumber, alpha3CountryCode) {
    const cleanedPhoneNumber = replace(phoneNumber, "\\D+", "");
    const matchValue = alpha3CountryCode.ThreeLetter.toLocaleUpperCase();
    switch (matchValue) {
        case "SWE": {
            let regexMatch;
            const tupledArg = [cleanedPhoneNumber, "^(\\+)?(00)?(0)?(460)?(46)?(.*)$"];
            regexMatch = match(create(tupledArg[1]), tupledArg[0]);
            if (regexMatch != null) {
                return "46" + (regexMatch[6] || "");
            }
            else {
                return cleanedPhoneNumber;
            }
        }
        case "NOR": {
            let regexMatch_1;
            const tupledArg_1 = [cleanedPhoneNumber, "^(\\+)?(00)?(0)?(470)?(47)?(.*)$"];
            regexMatch_1 = match(create(tupledArg_1[1]), tupledArg_1[0]);
            if (regexMatch_1 != null) {
                return "47" + (regexMatch_1[6] || "");
            }
            else {
                return cleanedPhoneNumber;
            }
        }
        case "FIN": {
            let regexMatch_2;
            const tupledArg_2 = [cleanedPhoneNumber, "^(\\+)?(00)?(0)?(3580)?(358)?(.*)$"];
            regexMatch_2 = match(create(tupledArg_2[1]), tupledArg_2[0]);
            if (regexMatch_2 != null) {
                return "358" + (regexMatch_2[6] || "");
            }
            else {
                return cleanedPhoneNumber;
            }
        }
        default: {
            logw(toText(printf("Cannot normalize phoneNumber (%s), missing implementation for country: %s."))(phoneNumber)(matchValue));
            return phoneNumber;
        }
    }
}

export function startsWith(startWith, str) {
    return str.indexOf(startWith) === 0;
}

export function isMobileNumber(alpha3CountryCode, number) {
    const matchValue = alpha3CountryCode.toLocaleUpperCase();
    switch (matchValue) {
        case "SWE": {
            return startsWith("467", number);
        }
        case "NOR": {
            if (startsWith("479", number)) {
                return true;
            }
            else {
                return startsWith("474", number);
            }
        }
        case "FIN": {
            if (startsWith("3584", number) ? true : startsWith("358457", number)) {
                return true;
            }
            else {
                return startsWith("35850", number);
            }
        }
        default: {
            logw(toText(printf("Cannot determine if phoneNumber is mobile (%s), missing implementation for country: %s."))(number)(matchValue));
            return true;
        }
    }
}

export function truncateString(maxLength, source) {
    if (maxLength < 1) {
        return "";
    }
    else if (source.length <= maxLength) {
        return source;
    }
    else {
        return source.slice(void 0, (maxLength - 1) + 1);
    }
}

export function truncateWithEllipsis(maxLength, source) {
    if (maxLength < 1) {
        return "";
    }
    else if (source.length <= maxLength) {
        return source;
    }
    else {
        return source.slice(void 0, (maxLength - 1) + 1) + "...";
    }
}

export function getInitials(name) {
    const name_1 = name.trim();
    return defaultArg(map_1((names) => {
        const getInitial = (str) => defaultArg(map_1((name_2) => {
            if (name_2.length === 0) {
                return "?";
            }
            else {
                return substring(name_2, 0, 1);
            }
        }, str), "?");
        return getInitial(tryHead(names)) + getInitial(tryLast(names));
    }, map_1((sep) => split(name_1, [sep], null, 0), (name_1.indexOf(" ") >= 0) ? " " : ((name_1.indexOf("-") >= 0) ? "-" : (void 0)))), (name_1.length < 2) ? "??" : substring(name_1, 0, 2));
}

export function createThrottle(ms) {
    let before = now_1();
    return (f) => {
        let copyOfStruct;
        const now = now_1();
        if (((copyOfStruct = op_Subtraction(now, before), copyOfStruct)) > ms) {
            before = now;
            f();
        }
    };
}

function createDebounce$0027(ms) {
    let debounceTimerId2 = 0;
    return (f) => {
        window.clearTimeout(debounceTimerId2);
        debounceTimerId2 = window.setTimeout(f, ms);
    };
}

export const createDebounce = memoize(createDebounce$0027);

export function String_toLowerCase(str) {
    return str.toLocaleLowerCase();
}

export function String_capitalize(str) {
    let copyOfStruct;
    if (isNullOrWhiteSpace(str)) {
        return str;
    }
    else if (str.length === 1) {
        return str.toLocaleUpperCase();
    }
    else {
        return ((copyOfStruct = str[0].toLocaleUpperCase(), copyOfStruct)) + substring(str, 1);
    }
}

export function String_contains(searchStr, str) {
    return str.indexOf(searchStr) >= 0;
}

export function String_replace(oldStr, newStr, str) {
    return replace_1(str, oldStr, newStr);
}

export function String_endsWith(endsWithStr, str) {
    return endsWith(str, endsWithStr);
}

export function stripHtmlTags(input) {
    const sb = StringBuilder_$ctor();
    fold_2((flag, c) => {
        if (c === "\u003c") {
            return false;
        }
        else if (c === "\u003e") {
            return true;
        }
        else if (flag) {
            StringBuilder__Append_244C7CD6(sb, c);
            return true;
        }
        else {
            return false;
        }
    }, true, input);
    return toString(sb);
}

export function containsHtmlTags(input) {
    return match(/<\w/gu, input) != null;
}

export function delayAsync(ms, cont) {
    return singleton.Delay(() => singleton.Bind(sleep(ms), () => singleton.Return(cont())));
}

export class Byte {
    constructor() {
    }
}

export function Byte$reflection() {
    return class_type("Utils.Byte", void 0, Byte);
}

export function Byte_get_BytesPerKiloByte() {
    return fromParts(10240, 0, 0, false, 1);
}

export function Byte_get_BytesPerMegaByte() {
    return fromParts(10485760, 0, 0, false, 1);
}

export function Byte_get_BytesPerGigaByte() {
    return fromParts(-2147483648, 2, 0, false, 1);
}

export function Byte_get_BytesPerTeraByte() {
    return fromParts(0, 2560, 0, false, 1);
}

export function Byte_get_BytesPerKiloByteTrafficReport() {
    return fromParts(10000, 0, 0, false, 1);
}

export function Byte_get_BytesPerMegaByteTrafficReport() {
    return fromParts(10000000, 0, 0, false, 1);
}

export function Byte_get_BytesPerGigaByteTrafficReport() {
    return fromParts(1410065408, 2, 0, false, 1);
}

export function Byte_get_BytesPerTeraByteTrafficReport() {
    return fromParts(1316134912, 2328, 0, false, 1);
}

export function Byte_ToString_Z3EC7497(bytes, precision, withSpace) {
    let precision_1;
    const arg = defaultArg(precision, 1) | 0;
    precision_1 = Math.abs(arg);
    const withSpace_1 = defaultArg(withSpace, true);
    let tupledArg;
    const matchValue = new Decimal(toNumber(bytes));
    tupledArg = ((compare(op_Division(matchValue, Byte_get_BytesPerTeraByte()), fromParts(10, 0, 0, false, 1)) >= 0) ? [round(op_Division(matchValue, Byte_get_BytesPerTeraByte()), precision_1), "TB"] : ((compare(op_Division(matchValue, Byte_get_BytesPerGigaByte()), fromParts(10, 0, 0, false, 1)) >= 0) ? [round(op_Division(matchValue, Byte_get_BytesPerGigaByte()), precision_1), "GB"] : ((compare(op_Division(matchValue, Byte_get_BytesPerMegaByte()), fromParts(10, 0, 0, false, 1)) >= 0) ? [round(op_Division(matchValue, Byte_get_BytesPerMegaByte()), precision_1), "MB"] : ((compare(op_Division(matchValue, Byte_get_BytesPerKiloByte()), fromParts(10, 0, 0, false, 1)) >= 0) ? [round(op_Division(matchValue, Byte_get_BytesPerKiloByte()), precision_1), "kB"] : [new Decimal(toNumber(bytes)), "B"]))));
    const spaceChar = withSpace_1 ? " " : "";
    return toText(printf("%M%s%s"))(tupledArg[0])(spaceChar)(tupledArg[1]);
}

export function Byte_ToStringTrafficReport_Z3EC7497(bytes, precision, withSpace) {
    let precision_1;
    const arg = defaultArg(precision, 1) | 0;
    precision_1 = Math.abs(arg);
    const withSpace_1 = defaultArg(withSpace, true);
    let tupledArg;
    const matchValue = new Decimal(toNumber(bytes));
    tupledArg = ((compare(op_Division(matchValue, Byte_get_BytesPerTeraByteTrafficReport()), fromParts(10, 0, 0, false, 1)) >= 0) ? [round(op_Division(matchValue, Byte_get_BytesPerTeraByteTrafficReport()), precision_1), "TB"] : ((compare(op_Division(matchValue, Byte_get_BytesPerGigaByteTrafficReport()), fromParts(10, 0, 0, false, 1)) >= 0) ? [round(op_Division(matchValue, Byte_get_BytesPerGigaByteTrafficReport()), precision_1), "GB"] : ((compare(op_Division(matchValue, Byte_get_BytesPerMegaByteTrafficReport()), fromParts(10, 0, 0, false, 1)) >= 0) ? [round(op_Division(matchValue, Byte_get_BytesPerMegaByteTrafficReport()), precision_1), "MB"] : ((compare(op_Division(matchValue, Byte_get_BytesPerKiloByteTrafficReport()), fromParts(10, 0, 0, false, 1)) >= 0) ? [round(op_Division(matchValue, Byte_get_BytesPerKiloByteTrafficReport()), precision_1), "kB"] : [new Decimal(toNumber(bytes)), "B"]))));
    const spaceChar = withSpace_1 ? " " : "";
    return toText(printf("%M%s%s"))(tupledArg[0])(spaceChar)(tupledArg[1]);
}

export function Result_toOption(_arg) {
    if (_arg.tag === 1) {
        return void 0;
    }
    else {
        return some(_arg.fields[0]);
    }
}

export function Result_toBool(_arg) {
    if (_arg.tag === 1) {
        return false;
    }
    else {
        return true;
    }
}

export class FlatpickrLocale {
    constructor() {
    }
}

export function FlatpickrLocale$reflection() {
    return class_type("Utils.FlatpickrLocale", void 0, FlatpickrLocale);
}

export function FlatpickrLocale_get_defaultLocale() {
    return Swedish;
}

export function FlatpickrLocale_get_FromSelectedLanguage() {
    return (_arg) => {
        switch (_arg) {
            case "sv": {
                return Swedish;
            }
            case "fi": {
                return Finnish;
            }
            case "nb": {
                return Norwegian;
            }
            case "en": {
                return english;
            }
            default: {
                loge(toText(printf("[FlatpickrLocale - fromSelectedLanguage] Unsupported: \u0027%s\u0027."))(_arg));
                return FlatpickrLocale_get_defaultLocale();
            }
        }
    };
}

export function translation(str, t) {
    switch (str) {
        case "svSE": {
            return t.svSE;
        }
        case "fiFI": {
            return t.fiFI;
        }
        case "nbNO": {
            return t.nbNO;
        }
        case "enGB": {
            return t.enGB;
        }
        default: {
            return t.svSE;
        }
    }
}

export class Locale extends Record {
    constructor(ILocale, FlatpickrLocale, Language) {
        super();
        this.ILocale = ILocale;
        this.FlatpickrLocale = FlatpickrLocale;
        this.Language = Language;
    }
}

export function Locale$reflection() {
    return record_type("Utils.Locale", [], Locale, () => [["ILocale", class_type("Fable.DateFunctions.ILocale")], ["FlatpickrLocale", class_type("Flatpickr.IFlatpickrLocale")], ["Language", string_type]]);
}

export function Locale_get_defaultLocale() {
    return new Locale(sv, Swedish, "svSE");
}

export function Locale__Translate_Z6CB79190(x, t) {
    return translation(x.Language, t);
}

export function Locale_get_FromSelectedLanguage() {
    return memoize((selectedLanguage) => {
        const flatpickrLocale = FlatpickrLocale_get_FromSelectedLanguage()(selectedLanguage);
        switch (selectedLanguage) {
            case "sv": {
                return new Locale(sv, flatpickrLocale, "svSE");
            }
            case "fi": {
                return new Locale(fi, flatpickrLocale, "fiFI");
            }
            case "nb": {
                return new Locale(nb, flatpickrLocale, "nbNO");
            }
            case "en": {
                return new Locale(enGB, flatpickrLocale, "enGB");
            }
            default: {
                loge(toText(printf("[Locale - fromSelectedLanguage] Unsupported: \u0027%s\u0027."))(selectedLanguage));
                return Locale_get_defaultLocale();
            }
        }
    });
}

export function Utilities_Translations_Translation__Translation_Translate_71D50F94(this$, locale) {
    return translation(locale.Language, this$);
}

export function DateTimeExtensions_yyyy_MM_dd(date) {
    return toString_1(date, "yyyy-MM-dd");
}

export function DateTimeExtensions_yyyy_MM_dd_HH_mm_ss(date) {
    return toString_1(date, "yyyy-MM-dd HH:mm:ss");
}

export function DateTimeExtensions_yyyy_MM_ddZ(date) {
    let copyOfStruct = toUniversalTime(date);
    return toString_1(copyOfStruct, "yyyy-MM-ddZ");
}

export function DateTimeExtensions_yyyy_MM_ddTHH_mm_ssZ(date) {
    let copyOfStruct = toUniversalTime(date);
    return toString_1(copyOfStruct, "yyyy-MM-ddTHH:mm:ssZ");
}

export function DateTimeExtensions_yyyy_MM_ddTHH_mm_ss_fffZ(date) {
    let copyOfStruct = toUniversalTime(date);
    return toString_1(copyOfStruct, "yyyy-MM-ddTHH:mm:ss.fffZ");
}

export function DateTimeExtensions_yyyy_MM_ddTHH_mm_ss_fffffffZ(date) {
    let copyOfStruct = toUniversalTime(date);
    return toString_1(copyOfStruct, "yyyy-MM-ddTHH:mm:ss.fffffffZ");
}

export const DateTimeExtensions_toIso8601 = DateTimeExtensions_yyyy_MM_ddTHH_mm_ssZ;

export const DateTimeExtensions_toShortDate = DateTimeExtensions_yyyy_MM_dd;

export function DateTimeExtensions_toDate(locale, date) {
    const formatOptions = {};
    formatOptions.locale = locale;
    return format_1(date, "P", formatOptions);
}

export function DateTimeExtensions_toDateHHmm(locale, date) {
    const formatOptions = {};
    formatOptions.locale = locale;
    return format_1(date, "Pp", formatOptions);
}

export function DateTimeExtensions_toDateHHmmss(locale, date) {
    const formatOptions = {};
    formatOptions.locale = locale;
    return format_1(date, "Ppp", formatOptions);
}

export function DateTimeExtensions_toShortMonth(locale, date) {
    const formatOptions = {};
    formatOptions.locale = locale;
    return format_1(date, "MMM", formatOptions);
}

export function DateTimeExtensions_toLongMonth(locale, date) {
    const formatOptions = {};
    formatOptions.locale = locale;
    return format_1(date, "MMMM", formatOptions);
}

export function DateTimeExtensions_toLongDayOfWeek(locale, date) {
    const formatOptions = {};
    formatOptions.locale = locale;
    return format_1(date, "EEEE", formatOptions);
}

export function DateTimeExtensions_to1stInMonth(date) {
    return addDays(date, op_UnaryNegation_Int32(day(date)) + 1);
}

export function DateTimeExtensions_toLastOfMonth(date) {
    return create_1(year(date), month(date), daysInMonth(year(date), month(date)));
}

export function DateTimeExtensions_toYearLongMonth(locale, date) {
    const formatOptions = {};
    formatOptions.locale = locale;
    return format_1(date, "yyyy MMMM", formatOptions);
}

export function DateTimeExtensions_changeTime(hours, minutes, seconds, milliseconds, date) {
    return create_1(year(date), month(date), day(date), hours, minutes, seconds, milliseconds);
}

export function DateTimeExtensions_getAbsoluteMonthDiff(date1, date2) {
    return Math.abs(((year(date1) * 12) + month(date1)) - ((year(date2) * 12) + month(date2)));
}

export function DateTimeExtensions_toUtc(date) {
    return value_2(UTC_ofDateTime_7F9DDECF(toUniversalTime(date)));
}

export function DateTimeExtensions_getMonthDiff(startDate, endDate) {
    return ((year_1(endDate) - year_1(startDate)) * 12) + (month_1(endDate) - month_1(startDate));
}

export function DateTimeOffsetExtensions_yyyy_MM_dd(date) {
    return toString_1(date, "yyyy-MM-dd");
}

export function DateTimeOffsetExtensions_yyyy_MM_dd_HH_mm_ss(date) {
    return toString_1(date, "yyyy-MM-dd HH:mm:ss");
}

export function DateTimeOffsetExtensions_yyyy_MM_ddZ(date) {
    let copyOfStruct = toUniversalTime_1(date);
    return toString_1(copyOfStruct, "yyyy-MM-ddZ");
}

export function DateTimeOffsetExtensions_yyyy_MM_ddThh_mm_ssZ(date) {
    let copyOfStruct = toUniversalTime_1(date);
    return toString_1(copyOfStruct, "yyyy-MM-ddTHH:mm:ssZ");
}

export function DateTimeOffsetExtensions_yyyy_MM_ddTHH_mm_ss_fffZ(date) {
    let copyOfStruct = toUniversalTime_1(date);
    return toString_1(copyOfStruct, "yyyy-MM-ddTHH:mm:ss.fffZ");
}

export function DateTimeOffsetExtensions_yyyy_MM_ddTHH_mm_ss_fffffffZ(date) {
    let copyOfStruct = toUniversalTime_1(date);
    return toString_1(copyOfStruct, "yyyy-MM-ddTHH:mm:ss.fffffffZ");
}

export const DateTimeOffsetExtensions_toIso8601 = DateTimeOffsetExtensions_yyyy_MM_ddThh_mm_ssZ;

export function DateTimeOffsetExtensions_toDate(locale, date) {
    const formatOptions = {};
    formatOptions.locale = locale;
    return format_1(date, "P", formatOptions);
}

export function DateTimeOffsetExtensions_toDateHHmm(locale, date) {
    const formatOptions = {};
    formatOptions.locale = locale;
    return format_1(date, "Pp", formatOptions);
}

export function DateTimeOffsetExtensions_toDateHHmmss(locale, date) {
    const formatOptions = {};
    formatOptions.locale = locale;
    return format_1(date, "Ppp", formatOptions);
}

export function DateTimeOffsetExtensions_toShortMonth(locale, date) {
    const formatOptions = {};
    formatOptions.locale = locale;
    return format_1(date, "MMM", formatOptions);
}

export function DateTimeOffsetExtensions_toLongMonth(locale, date) {
    const formatOptions = {};
    formatOptions.locale = locale;
    return format_1(date, "MMMM", formatOptions);
}

export function DateTimeOffsetExtensions_toLongDayOfWeek(locale, date) {
    const formatOptions = {};
    formatOptions.locale = locale;
    return format_1(date, "EEEE", formatOptions);
}

export function DateTimeOffsetExtensions_to1stInMonth(date) {
    return addDays_1(date, op_UnaryNegation_Int32(day_1(date)) + 1);
}

export function DateTimeOffsetExtensions_toLastOfMonth(date) {
    const nextMonth = addMonths(date, 1);
    return addDays_1(nextMonth, op_UnaryNegation_Int32(day_1(nextMonth)));
}

export function DateTimeOffsetExtensions_toYearLongMonth(locale, date) {
    const formatOptions = {};
    formatOptions.locale = locale;
    return format_1(date, "yyyy MMMM", formatOptions);
}

export function DateTimeOffsetExtensions_changeTime(hours, minutes, seconds, milliseconds, date) {
    return create_1(year(date), month(date), day(date), hours, minutes, seconds, milliseconds);
}

export function DateTimeOffsetExtensions_getMonthDiff(date1, date2) {
    return Math.abs(((year(date1) * 12) + month(date1)) - ((year(date2) * 12) + month(date2)));
}

export function DateTimeOffsetExtensions_toUtc(date) {
    let copyOfStruct;
    return value_2(UTC_ofDateTime_7F9DDECF((copyOfStruct = fromDateTimeOffset(date, 0), toUniversalTime(copyOfStruct))));
}

export function DateOnlyExtensions_yyyy_MM_dd(date) {
    const dateStr = (number) => {
        if (number < 10) {
            return toText(printf("0%i"))(number);
        }
        else {
            return toText(printf("%i"))(number);
        }
    };
    const arg_4 = dateStr(day_2(date));
    const arg_3 = dateStr(month_1(date));
    const arg_2 = year_1(date) | 0;
    return toText(printf("%i-%s-%s"))(arg_2)(arg_3)(arg_4);
}

export function DateOnlyExtensions_yyyyMMdd(date) {
    const dateStr = (number) => {
        if (number < 10) {
            return toText(printf("0%i"))(number);
        }
        else {
            return toText(printf("%i"))(number);
        }
    };
    const arg_4 = dateStr(day_2(date));
    const arg_3 = dateStr(month_1(date));
    const arg_2 = year_1(date) | 0;
    return toText(printf("%i%s%s"))(arg_2)(arg_3)(arg_4);
}

export function DateOnlyExtensions_yyyy_MM(date) {
    let arg_3;
    const number = month_1(date) | 0;
    arg_3 = ((number < 10) ? toText(printf("0%i"))(number) : toText(printf("%i"))(number));
    const arg_2 = year_1(date) | 0;
    return toText(printf("%i-%s"))(arg_2)(arg_3);
}

export function DateOnlyExtensions_to1stInMonth(date) {
    return addDays(date, op_UnaryNegation_Int32(day_2(date)) + 1);
}

export function DateOnlyExtensions_toLastOfMonth(date) {
    const nextMonth = addMonths_1(date, 1);
    return addDays(nextMonth, op_UnaryNegation_Int32(day_2(nextMonth)));
}

export function DateOnlyExtensions_toDate(locale, date) {
    return DateTimeExtensions_toDate(locale, toDateTime(date, create_2(0, 0, 0)));
}

export function DateOnlyExtensions_fromDateTime(dt) {
    return create_3(year(dt), month(dt), day(dt));
}

export function DateOnlyExtensions_toDateTime(date) {
    return create_1(year_1(date), month_1(date), day_2(date));
}

export function DateOnlyExtensions_getAbsoluteMonthDiff(date1, date2) {
    return Math.abs(((year_1(date1) * 12) + month_1(date1)) - ((year_1(date2) * 12) + month_1(date2)));
}

export function DateOnlyExtensions_getMonthDiff(startDate, endDate) {
    return ((year_1(endDate) - year_1(startDate)) * 12) + (month_1(endDate) - month_1(startDate));
}

export function SveaDateExtensions_toDate(locale, date) {
    return DateTimeExtensions_toDate(locale, toDateTime(date, create_2(0, 0)));
}

export function querySelectorAll(selector) {
    const nodeList = document.querySelectorAll(selector);
    return map_2((i) => nodeList.item(i), toList_1(rangeDouble(0, 1, nodeList.length - 1)));
}

export function binSearch(target_mut, arr_mut) {
    binSearch:
    while (true) {
        const target = target_mut, arr = arr_mut;
        const matchValue = arr.length | 0;
        if (matchValue === 0) {
            return void 0;
        }
        else {
            const middle = (~(~(matchValue / 2))) | 0;
            const matchValue_1 = sign(compare_1(target, arr[middle])) | 0;
            switch (matchValue_1) {
                case -1: {
                    target_mut = target;
                    arr_mut = arr.slice(void 0, (middle - 1) + 1);
                    continue binSearch;
                }
                case 0: {
                    return some(target);
                }
                default: {
                    target_mut = target;
                    arr_mut = arr.slice(middle + 1, arr.length);
                    continue binSearch;
                }
            }
        }
        break;
    }
}

export function parseQueryParams(stringWithParams) {
    const matchValue_1 = stringWithParams.indexOf("?") | 0;
    if (matchValue_1 === -1) {
        return empty();
    }
    else {
        return ofArray_1(choose((x) => x, map_3((str) => {
            const arr = split(str, ["="], null, 0);
            if (arr.length === 2) {
                return [arr[0], arr[1]];
            }
            else {
                return void 0;
            }
        }, split(replace_1(substring(stringWithParams, matchValue_1), "?", "\u0026"), ["\u0026"], null, 0))));
    }
}

export function Map_merge(map1, map2) {
    return fold_3((acc, key, value) => add(key, value, acc), map1, map2);
}

export function Map_mergeWith(map1, map2, f) {
    return fold_3((acc, key, value) => {
        const matchValue = tryFind(key, acc);
        return (matchValue == null) ? add(key, value, acc) : add(key, f(key, [value_2(matchValue), value]), acc);
    }, map1, map2);
}

export function greatest(a, b) {
    if (compare_2(a, b) > 0) {
        return a;
    }
    else {
        return b;
    }
}

export function getRemainingBoundMonths(clientNr, now, startDate, createdDate, boundMonths) {
    const today = DateOnlyExtensions_fromDateTime(now);
    const swap = ((compare_2(create_3(UTC__get_Year(createdDate), UTC__get_Month(createdDate), UTC__get_Day(createdDate)), startDate) < 0) ? 1 : 0) | 0;
    const beginningMonthNow = DateOnlyExtensions_to1stInMonth(today);
    const feeBoundToEndOfMonth = DateOnlyExtensions_toLastOfMonth(addMonths_1(startDate, boundMonths));
    const monthDiff = (DateOnlyExtensions_getAbsoluteMonthDiff(beginningMonthNow, feeBoundToEndOfMonth) * ((compare_2(feeBoundToEndOfMonth, beginningMonthNow) >= 0) ? 1 : -1)) | 0;
    const remaining = ((monthDiff < 0) ? 0 : ((clientNr === 21292) ? (monthDiff - swap) : monthDiff)) | 0;
    if (remaining < 0) {
        return 0;
    }
    else if (remaining > boundMonths) {
        return boundMonths | 0;
    }
    else {
        return remaining | 0;
    }
}

export function getRemainingBoundMonthsWithoutCancellationPeriod(billedTo, boundMonths, startDate) {
    const monthDiff = DateOnlyExtensions_getMonthDiff(defaultArg(billedTo, startDate), addMonths_1(startDate, boundMonths)) | 0;
    if (monthDiff < 0) {
        return 0;
    }
    else {
        return monthDiff | 0;
    }
}

export class Trie$1 extends Record {
    constructor(IsTerminal, Children) {
        super();
        this.IsTerminal = IsTerminal;
        this.Children = Children;
    }
}

export function Trie$1$reflection(gen0) {
    return record_type("Utils.Trie`1", [gen0], Trie$1, () => [["IsTerminal", bool_type], ["Children", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [gen0, Trie$1$reflection(gen0)])]]);
}

export function Trie_empty() {
    return new Trie$1(false, empty());
}

export function Trie_isEmpty(trie) {
    if (isEmpty(trie.Children)) {
        return !trie.IsTerminal;
    }
    else {
        return false;
    }
}

export function Trie_add(chars, trie) {
    let trie_1;
    const matchValue = tryHead_1(chars);
    if (matchValue != null) {
        const el = value_2(matchValue);
        return new Trie$1(trie.IsTerminal, add(el, (trie_1 = defaultArg(tryFind(el, trie.Children), Trie_empty()), Trie_add(tail(chars), trie_1)), trie.Children));
    }
    else {
        return new Trie$1(true, trie.Children);
    }
}

export function Trie_contains(chars, trie) {
    let chars_1;
    const matchValue = tryHead_1(chars);
    if (matchValue != null) {
        const option = tryFind(value_2(matchValue), trie.Children);
        return exists((chars_1 = tail(chars), (trie_1) => Trie_contains(chars_1, trie_1)), toArray(option));
    }
    else {
        return trie.IsTerminal;
    }
}

export function Trie_toSeq(trie) {
    return delay(() => collect((matchValue) => {
        const activePatternResult = matchValue;
        const trie_1 = activePatternResult[1];
        const label = activePatternResult[0];
        return append_1(trie_1.IsTerminal ? singleton_1(singleton_2(label)) : empty_1(), delay(() => map((child) => cons(label, child), Trie_toSeq(trie_1))));
    }, trie.Children));
}

export function Trie_getSuggestions(chars, trie) {
    const getSuggestions$0027 = (chars_1_mut, trie_1_mut) => {
        getSuggestions$0027:
        while (true) {
            const chars_1 = chars_1_mut, trie_1 = trie_1_mut;
            const matchValue = tryHead_1(chars_1);
            if (matchValue != null) {
                const matchValue_1 = tryFind(value_2(matchValue), trie_1.Children);
                if (matchValue_1 == null) {
                    return empty_1();
                }
                else {
                    const subTrie = matchValue_1;
                    chars_1_mut = tail(chars_1);
                    trie_1_mut = subTrie;
                    continue getSuggestions$0027;
                }
            }
            else {
                return Trie_toSeq(trie_1);
            }
            break;
        }
    };
    return map((word) => append(toList_1(chars), word), getSuggestions$0027(chars, trie));
}

export function Trie_remove(chars, trie) {
    const matchValue = tryHead_1(chars);
    if (matchValue != null) {
        const el = value_2(matchValue);
        const matchValue_1 = tryFind(el, trie.Children);
        if (matchValue_1 != null) {
            const child = matchValue_1;
            const updatedChild = Trie_remove(tail(chars), child);
            if (Trie_isEmpty(updatedChild)) {
                return new Trie$1(trie.IsTerminal, remove(el, trie.Children));
            }
            else {
                return new Trie$1(trie.IsTerminal, add(el, updatedChild, trie.Children));
            }
        }
        else {
            return trie;
        }
    }
    else {
        return new Trie$1(false, trie.Children);
    }
}

export function loadCssFile(cssUrl) {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = cssUrl;
    document.head.appendChild(link);
}

export function loadJsFile(jsUrl) {
    const script = document.createElement("script");
    script.src = jsUrl;
    script.type = "text/javascript";
    document.body.appendChild(script);
}

export function updateQueryParamInHash(queryParamName, value) {
    const parts = split(window.location.href, ["#"], null, 0);
    if (parts.length > 1) {
        const baseUrl = parts[0];
        const fragment = split(parts[1], ["?"], null, 0)[0];
        const newUrl = (baseUrl + "#") + (isNullOrWhiteSpace(value) ? fragment : ((fragment + toText(printf("?%s="))(queryParamName)) + value));
        window.history.replaceState(null, "", newUrl);
    }
}

export function getCookie(name) {
    return map_1((c_1) => substring(c_1, c_1.indexOf("=") + 1), tryFind_1((c) => (c.trimStart().indexOf(name + "=") === 0), split(document.cookie, [";"], null, 0)));
}

